// TODO: move this into runtime environment variables
export const googleMapApiKey = "AIzaSyCNxuZMsoYo60luivBGsByo4xNhlG0mZNA";
// TODO: move this into runtime environment variables
export const googleMapApiKey = "AIzaSyCNxuZMsoYo60luivBGsByo4xNhlG0mZNA";
